import TreeViewPage from "pages/TreeViewPage";
import React from "react";

const TreeViewRoute = () => <TreeViewPage />;

export default TreeViewRoute;
